<form [formGroup]="dateTimeForm">
  <div>
    <mat-calendar
      [selected]="selectedDate"
      (selectedChange)="onValueChange($event)"
    >
    </mat-calendar>
  </div>
  <div class="time-field" uk-grid>
    <div class="uk-width-auto">
      <span uk-icon="clock"></span>
    </div>
    <div class="uk-width-expand">
      <select class="uk-select" formControlName="time">
        <option value="">Set time</option>
        <option *ngFor="let hour of hours" [value]="hour">{{ hour }}</option>
      </select>
    </div>
  </div>
</form>
